import React from "react"
import { DialogContent, Dialog, Theme, useMediaQuery } from "@carrotfertility/carotene-core"
import { DialogCloseButton } from "@carrotfertility/carotene-core-x"
import { RecommendDoulaFormContainer } from "#/pages/provider-finder/recommend-doula/RecommendDoulaForm"

export function RecommendDoulaDialog({
  open,
  onClose,
  searchByNameInputValue
}: {
  open: boolean
  onClose: () => void
  searchByNameInputValue?: string
}): JSX.Element {
  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))
  return (
    <Dialog open={open} fullScreen={isMobileView}>
      <DialogCloseButton onClick={onClose} />
      <DialogContent sx={{ blockSize: "33rem" }}>
        <RecommendDoulaFormContainer {...{ searchByNameInputValue }} />
      </DialogContent>
    </Dialog>
  )
}
